/* unplugin-vue-components disabled */import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  key: 2,
  class: "menu-name"
};
const _hoisted_5 = {
  style: {
    "display": "block",
    "width": "240px",
    "overflow": "hidden",
    "text-overflow": "ellipsis",
    "white-space": "nowrap"
  }
};
const _hoisted_6 = {
  key: 0,
  style: {
    "margin-right": "1rem"
  }
};
const _hoisted_7 = {
  class: "textword",
  style: {
    "color": "#1890ff"
  }
};
const _hoisted_8 = {
  m: "4",
  style: {
    "margin-left": "2rem"
  }
};
const _hoisted_9 = {
  m: "t-0 b-2"
};
const _hoisted_10 = {
  m: "t-0 b-2"
};
const _hoisted_11 = {
  m: "t-0 b-2"
};
const _hoisted_12 = {
  key: 0,
  m: "t-0 b-2"
};
const _hoisted_13 = {
  key: 1,
  m: "t-0 b-2"
};
const _hoisted_14 = {
  key: 2,
  m: "t-0 b-2"
};
const _hoisted_15 = {
  key: 3,
  m: "t-0 b-2"
};
const _hoisted_16 = {
  m: "t-0 b-2"
};
const _hoisted_17 = {
  key: 4,
  style: {
    "margin-bottom": "1rem",
    "margin-right": "1rem"
  }
};
const _hoisted_18 = ["onUpdate:modelValue"];
const _hoisted_19 = {
  class: "el-dropdown-link"
};
const _hoisted_20 = {
  class: "textword"
};
const _hoisted_21 = {
  class: "loadingButton"
};
const _hoisted_22 = {
  class: "el-dropdown-link"
};
const _hoisted_23 = {
  key: 4,
  class: "mapView"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "dialog-footer"
};
const _hoisted_26 = {
  style: {
    "width": "80rem",
    "height": "18rem",
    "text-align": "center",
    "font-size": "1.8rem"
  }
};
const _hoisted_27 = {
  class: "div_allinline"
};
const _hoisted_28 = {
  class: "subdiv_allinline"
};
const _hoisted_29 = {
  class: "subdiv_allinline"
};
const _hoisted_30 = {
  key: 0,
  style: {
    "margin-top": "1rem"
  }
};
const _hoisted_31 = {
  key: 1,
  style: {
    "margin-top": "1rem"
  }
};
const _hoisted_32 = {
  key: 0,
  style: {
    "width": "80rem",
    "font-size": "1.8rem"
  }
};
const _hoisted_33 = {
  class: "div_allinline"
};
const _hoisted_34 = {
  class: "subdiv_allinline"
};
const _hoisted_35 = {
  class: "dialog-footer"
};
const _hoisted_36 = {
  class: "dialog-footer"
};
import axios from "axios";
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const showChild = ref(false);
    const isShow = ref(false);
    const dialogFormVisible = ref(false);
    const progressFlag = ref(false);
    const loadProgress = ref(0);
    const src = ref("");
    const url = ref("");
    const odmtoken = ref("");
    const title = ref("");
    const formLabelWidth = ref("10rem");
    const expandedRows = ref([]);
    const middleRowKeys = ref([]);
    const tableData = ref([]);
    const map = ref(new Map());
    const resultmap = ref(new Map());
    const countmap = ref(new Map());
    const statusmap = ref(new Map());
    const taskLog = ref({});
    const nodeList = ref([]);
    const presetTypes = ref([]);
    const selectType = ref(10);
    const isChecked = ref(false);
    const newTaskId = ref(undefined);
    const downloadOptions = ref([{
      value: "orthophoto.tif",
      label: '正射影像'
    }, {
      value: "dsm.tif",
      label: '地表模型'
    }, {
      value: "georeferenced_model.laz",
      label: '点云(LAZ)'
    }, {
      value: "textured_model.zip",
      label: '纹理模型'
    }, {
      value: "textured_model.glb",
      label: '纹理模型(glTF)'
    }, {
      value: "cameras.json",
      label: '相机参数'
    }, {
      value: "shots.geojson",
      label: '相机镜头'
    }, {
      value: "report.pdf",
      label: '质量报告'
    }, {
      value: "all.zip",
      label: '所有资产'
    }]);
    const permissionsOptions = ref([{
      value: 0,
      label: 'Read/Write'
    }, {
      value: 1,
      label: 'Read'
    }]);
    const partialList = ref([{
      value: true,
      label: '是'
    }, {
      value: false,
      label: '否'
    }]);
    const upload = reactive({
      open: false,
      headers: {},
      url: "",
      projectId: undefined,
      data: undefined
    });
    const image = reactive({
      open: false,
      count: 0,
      headers: {},
      projectId: undefined,
      url: "",
      title: ""
    });
    const data = reactive({
      form: {
        id: undefined,
        name: "",
        description: "",
        permissions: []
      },
      rules: {
        name: [{
          required: true,
          message: '名字不能为空',
          trigger: 'blur'
        }]
      },
      taskform: {
        auto_processing_node: false,
        name: "",
        options: [],
        partial: true,
        processing_node: undefined,
        resize_to: 2048
      }
    });
    const {
      form,
      rules,
      taskform
    } = toRefs(data);

    //获取token
    function getOdmToken() {
      const formData = new FormData();
      formData.append('username', "admin");
      formData.append('password', "satpro123");
      axios({
        method: "post",
        url: "/3d/api/token-auth/",
        data: formData
      }).then(result => {
        odmtoken.value = ' JWT  ' + result.data.token;
        getProjects();
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    ;
    //获取项目列表
    function getProjects() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "GET",
        url: "/3d/api/projects/?ordering=-created_at&page=1"
      };
      mgAxios.request(options).then(result => {
        tableData.value = result.data.results;
        result.data.results.map((item, index) => {
          countmap.value.set(item.id, item.tasks.length > 0 ? item.tasks.length + "个任务" : "");
        });
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    ;
    //获取任务列表
    function getExpandData(projectId) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "GET",
        url: "/3d/api/projects/" + projectId + "/tasks/?ordering=-created_at"
      };
      mgAxios.request(options).then(result => {
        map.value.set(projectId, result.data);
        result.data.map((item, index) => {
          if (!resultmap.value.get(item.id)) {
            taskLog.value = {
              "resultshow": false,
              "textarea": ""
            };
            resultmap.value.set(item.id, taskLog.value);
          }
          if (item.import_url !== "") {
            statusmap.value.set(item.id, item.status === 40 ? "已完成" : item.status === 50 ? "已取消" : item.status === 20 ? "导入中" : item.status === 30 ? item.last_error : "");
          } else {
            statusmap.value.set(item.id, item.status === 40 ? "已完成" : item.status === 50 ? "已取消" : item.status === 20 ? "处理节点" : item.status === 30 ? item.last_error : "图片大小调整中");
          }
          if (item.status !== 40 && item.status !== 50 && item.status !== 30) {
            setTimeout(() => {
              getExpandData(projectId);
              getResult(item);
            }, 1000);
          }
        });
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    ;
    function expandChange(row) {
      if (expandedRows.value.includes(row.id)) {
        expandedRows.value = expandedRows.value.filter(val => val !== row.id);
      } else {
        expandedRows.value = [];
        expandedRows.value.push(row.id);
        getExpandData(row.id);
      }
    }
    ;
    function expandMiddleChange(row) {
      if (middleRowKeys.value.includes(row.id)) {
        middleRowKeys.value = middleRowKeys.value.filter(val => val !== row.id);
      } else {
        middleRowKeys.value = [];
        middleRowKeys.value.push(row.id);
      }
    }
    ;
    function reset() {
      form.value = {
        id: undefined,
        name: "",
        description: "",
        permissions: []
      };
      proxy.resetForm("formRef");
    }
    ;
    //新增项目
    function projectAdd() {
      reset();
      title.value = '新建项目';
      dialogFormVisible.value = true;
    }
    ;
    //编辑项目
    function projectEdit(row) {
      reset();
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "GET",
        url: "/3d/api/projects/" + row.id + "/permissions/"
      };
      mgAxios.request(options).then(result => {
        title.value = '编辑项目';
        form.value = row;
        form.value.permissions = [];
        result.data.map(item => {
          if (item.permissions.length > 1) {
            item.per = 0;
          } else {
            item.per = 1;
          }
          form.value.permissions.push(item);
        });
        dialogFormVisible.value = true;
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function submitForm() {
      proxy.$refs["formRef"].validate(valid => {
        if (valid) {
          if (form.value.id !== undefined) {
            const mgAxios = axios.create({
              headers: {
                Authorization: odmtoken.value,
                "content-type": "application/json"
              },
              timeout: 15000
            });
            const options = {
              method: "POST",
              url: "/3d/api/projects/" + form.value.id + "/edit/",
              data: form.value
            };
            mgAxios.request(options).then(result => {
              dialogFormVisible.value = false;
              getProjects();
            }).catch(function (error) {
              //发生错误时的处理
              console.log(error);
            });
          } else {
            const mgAxios = axios.create({
              headers: {
                Authorization: odmtoken.value,
                "content-type": "application/json"
              },
              timeout: 15000
            });
            const options = {
              method: "POST",
              url: "/3d/api/projects/",
              data: form.value
            };
            mgAxios.request(options).then(result => {
              dialogFormVisible.value = false;
              getProjects();
            }).catch(function (error) {
              //发生错误时的处理
              console.log(error);
            });
          }
        }
      });
    }
    //关闭弹窗
    function handleClose() {
      title.value = "";
      form.value = {};
      dialogFormVisible.value = false;
    }
    //删除项目
    function projectDelete() {
      proxy.$modal.confirm("与此项目相关的所有任务、图像和模型将被永久删除。您确定要继续吗?").then(function () {
        const mgAxios = axios.create({
          headers: {
            Authorization: odmtoken.value,
            "content-type": "application/json"
          },
          timeout: 15000
        });
        const options = {
          method: "DELETE",
          url: "/3d/api/projects/" + form.value.id + "/"
        };
        mgAxios.request(options).then(result => {
          dialogFormVisible.value = false;
          getProjects();
        }).catch(function (error) {
          //发生错误时的处理
          console.log(error);
        });
      });
    }
    //复制项目
    function duplicate() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + form.value.id + "/duplicate/"
      };
      mgAxios.request(options).then(result => {
        dialogFormVisible.value = false;
        getProjects();
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function viewAllMap(row) {
      src.value = "http://192.168.20.108:8000/map/project/" + row.id + "/";
      showChild.value = true;
    }
    //查看地图
    function viewMap(row, type) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      var formData = new FormData();
      formData.append('public', true);
      const options = {
        method: "PATCH",
        url: "/3d/api/projects/" + row.project + "/tasks/" + row.id + "/",
        data: formData
      };
      mgAxios.request(options).then(result => {
        if ("3d" === type) {
          src.value = "http://192.168.20.108:8000/public/task/" + row.id + "/3d/";
        } else {
          src.value = "http://192.168.20.108:8000/public/task/" + row.id + "/map/";
        }
        src.value = encodeURI(src.value);
        showChild.value = true;
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function goBack() {
      src.value = "";
      showChild.value = false;
    }
    //删除任务
    function deleteTask(row) {
      proxy.$modal.confirm("与此任务相关的所有信息，包括图像、地图和模型，都将被删除。您确定要继续吗?").then(function () {
        const mgAxios = axios.create({
          headers: {
            Authorization: odmtoken.value,
            "content-type": "application/json"
          },
          timeout: 15000
        });
        const options = {
          method: "POST",
          url: "/3d/api/projects/" + row.project + "/tasks/" + row.id + "/remove/",
          data: {
            "uuid": row.uuid
          }
        };
        mgAxios.request(options).then(result => {
          getTaskCount(row.project);
          getExpandData(row.project);
        }).catch(function (error) {
          //发生错误时的处理
          console.log(error);
        });
      });
    }
    function taskRunCancel(row) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + row.project + "/tasks/" + row.id + "/cancel/",
        data: {
          "uuid": row.uuid
        }
      };
      mgAxios.request(options).then(result => {
        getExpandData(row.project);
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function addPermissions() {
      form.value.permissions.push({
        username: "",
        owner: false,
        per: 1
      });
    }
    function delPermissions(index) {
      form.value.permissions.splice(index, 1);
    }
    function getTaskCount(projectId) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "GET",
        url: "/3d/api/projects/" + projectId + "/"
      };
      mgAxios.request(options).then(result => {
        countmap.value.set(projectId, result.data.tasks.length > 0 ? result.data.tasks.length + "个任务" : "");
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function formateName(row) {
      return row.name !== null && row.name !== "" ? row.name : "Task #" + row.id;
    }
    function getOptions(options) {
      if (options.length > 0) {
        return options[0].name + ":" + options[0].value;
      } else {
        return "Default";
      }
    }

    //导入
    function handleImport(row) {
      upload.projectId = row.id;
      upload.url = "http://192.168.20.108:8000/api/projects/" + row.id + "/tasks/import";
      upload.headers = {
        Authorization: odmtoken.value
      };
      const str = JSON.stringify(new Date());
      upload.data = {
        "name": "Task of " + str.substring(1, str.length - 1)
      };
      upload.open = true;
    }
    function changeImport() {
      isShow.value = !isShow.value;
    }
    //上传进度条动态显示
    function handleProgress(event, file, fileList) {
      isShow.value = false;
      progressFlag.value = true; // 显示进度条
      loadProgress.value = parseInt(event.percent); // 动态获取文件上传进度
      if (loadProgress.value >= 100) {
        loadProgress.value = 100;
        setTimeout(() => {
          progressFlag.value = false;
        }, 1000); // 一秒后关闭进度条
      }
    }
    // 上传失败
    function handleUploadError(err) {
      proxy.$modal.msgError('上传失败, 请重试');
    }
    // 上传成功回调
    function handleUploadSuccess(res, file) {
      upload.open = false;
      proxy.$modal.msgSuccess('上传成功');
      getTaskCount(res.project);
      getExpandData(res.project);
      upload.headers = {};
      upload.url = "";
      upload.projectId = undefined;
      upload.data = undefined;
    }
    //上传取消，中断请求
    function handleCancel() {
      loadProgress.value = 0;
      progressFlag.value = false;
      proxy.$refs["uploadRef"].abort();
      proxy.$refs["uploadRef"].clearFiles();
    }
    //获取任务输出
    function getResult(row) {
      taskLog.value = resultmap.value.get(row.id);
      if (taskLog.value.resultshow) {
        const mgAxios = axios.create({
          headers: {
            Authorization: odmtoken.value,
            "content-type": "application/json"
          },
          timeout: 15000
        });
        const options = {
          method: "GET",
          url: "/3d/api/projects/" + row.project + "/tasks/" + row.id + "/output/?line=0"
        };
        mgAxios.request(options).then(result => {
          taskLog.value.textarea = result.data;
          resultmap.value.set(row.id, taskLog.value);
          setTimeout(function () {
            var textarea = document.getElementById('talkContent');
            textarea.scrollTop = textarea.scrollHeight;
          }, 500);
        }).catch(function (error) {
          //发生错误时的处理
          console.log(error);
        });
      }
    }
    //url导入
    function urlImport() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const str = JSON.stringify(new Date());
      upload.data = {};
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + upload.projectId + "/tasks/import",
        data: {
          "url": url.value,
          "name": "Task of " + str.substring(1, str.length - 1)
        }
      };
      mgAxios.request(options).then(result => {
        upload.open = false;
        getTaskCount(result.data.project);
        getExpandData(result.data.project);
        upload.headers = {};
        upload.url = "";
        upload.projectId = undefined;
        upload.data = undefined;
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    //图片导入
    function handleSelectPic(row) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      let options = {
        method: "GET",
        url: "/3d/api/processingnodes/?has_available_options=True"
      };
      mgAxios.request(options).then(result => {
        nodeList.value = result.data;
        nodeList.value.map(item => {
          if (item.online) {
            taskform.value.processing_node = item.id;
          }
        });
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
      options = {
        method: "GET",
        url: "/3d/api/presets/?ordering=-system,-created_at"
      };
      mgAxios.request(options).then(result => {
        presetTypes.value = result.data;
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
      image.projectId = row.id;
      const str = JSON.stringify(new Date());
      taskform.value.name = "Task of " + str.substring(1, str.length - 1);
      image.title = "选择图片和GCP";
      image.open = true;
    }
    function setOption(type) {
      taskform.value.options = [];
      presetTypes.value.map(item => {
        if (item.id === type) {
          taskform.value.options = item.options;
        }
      });
    }
    function taskSubmitForm() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + image.projectId + "/tasks/",
        data: taskform.value
      };
      mgAxios.request(options).then(result => {
        newTaskId.value = undefined;
        newTaskId.value = result.data.id;
        image.url = "http://192.168.20.108:8000/api/projects/" + image.projectId + "/tasks/" + newTaskId.value + "/upload/";
        image.headers = {
          Authorization: odmtoken.value
        };
        proxy.$refs["uploadImgRef"].submit();
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function handleUploadChange(event, file) {
      image.count = file.length;
    }
    const fileList = ref([]);
    function handleImageUploadSuccess(event, file, filelist) {
      fileList.value.push(file);
      if (filelist.length === fileList.value.length) {
        taskCommit();
      }
    }
    function taskCommit() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + image.projectId + "/tasks/" + newTaskId.value + "/commit/"
      };
      mgAxios.request(options).then(result => {
        getTaskCount(image.projectId);
        getExpandData(image.projectId);
        image.open = false;
        image.title = "";
        image.count = 0;
        image.headers = {};
        image.url = "";
        image.projectId = undefined;
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function taskCancel() {
      if (isChecked.value) {
        isChecked.value = false;
      } else {
        image.open = false;
        image.title = "";
      }
    }
    function taskCheck() {
      isChecked.value = true;
    }
    const projectionOptions = ref([{
      value: "4326",
      label: '纬度/经度 (EPSG:4326)'
    }, {
      value: "3857",
      label: 'Web 墨卡托 (EPSG:3857)'
    }, {
      value: "32644",
      label: 'UTM (EPSG:32644)'
    }, {
      value: "custom",
      label: '自定义 EPSG'
    }]);
    const formatOptions = ref([{
      value: "gtiff",
      label: 'GeoTIFF (Raw)'
    }, {
      value: "gtiff-rgb",
      label: 'GeoTIFF (RGB)'
    }, {
      value: "jpg",
      label: 'JPEG (RGB)'
    }, {
      value: "png",
      label: 'PNG (RGB)'
    }, {
      value: "kmz",
      label: 'KMZ (RGB)'
    }]);
    const lasOptions = ref([{
      value: "laz",
      label: 'LAZ'
    }, {
      value: "las",
      label: 'LAS'
    }, {
      value: "ply",
      label: 'PLY'
    }, {
      value: "csv",
      label: 'CSV'
    }]);
    const downloadModel = reactive({
      loading: false,
      open: false,
      title: "",
      format: undefined,
      epsg: undefined,
      epsgvalue: undefined,
      projectId: undefined,
      taskId: undefined,
      type: undefined
    });
    function downloadModelCancel() {
      downloadModel.title = "";
      downloadModel.epsg = undefined;
      downloadModel.epsgvalue = undefined;
      downloadModel.format = undefined;
      downloadModel.projectId = undefined;
      downloadModel.taskId = undefined;
      downloadModel.type = undefined;
      downloadModel.open = false;
      downloadModel.loading = false;
    }
    function downloadModelCommit() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const formData = new FormData();
      formData.append('format', downloadModel.format);
      formData.append('epsg', downloadModel.epsg === 'custom' ? downloadModel.epsgvalue : downloadModel.epsg);
      if (downloadModel.type === "dsm") {
        formData.append('hillshade', "6");
        formData.append('color_map', "viridis");
      }
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + downloadModel.projectId + "/tasks/" + downloadModel.taskId + "/" + downloadModel.type + "/export",
        data: formData
      };
      mgAxios.request(options).then(result => {
        if (result.data.celery_task_id !== null && result.data.celery_task_id !== undefined && result.data.url === undefined) {
          workersCheck("/3d/api/workers/check/" + result.data.celery_task_id, result.data.filename, result.data.celery_task_id);
          downloadModel.loading = true;
        }
        if (result.data.url !== null && result.data.url !== undefined && result.data.celery_task_id === undefined) {
          downloadFile("/3d" + result.data.url + "?filename=" + result.data.filename, result.data.filename);
        }
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function workersCheck(url, filename, celery_task_id) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "get",
        url: url
      };
      mgAxios.request(options).then(response => {
        if (!response.data.ready) {
          setTimeout(function () {
            workersCheck(url, filename, celery_task_id);
          }, 1000);
        } else {
          downloadFile("/3d/api/workers/get/" + celery_task_id + "?filename=" + filename, filename);
        }
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function handleDownloadCommand(command, row) {
      switch (command) {
        case "orthophoto.tif":
          downloadModel.title = "正射影像";
          downloadModel.epsg = "32644";
          downloadModel.epsgvalue = 4326;
          downloadModel.format = "gtiff";
          downloadModel.projectId = row.project;
          downloadModel.taskId = row.id;
          downloadModel.type = "orthophoto";
          downloadModel.open = true;
          break;
        case "dsm.tif":
          downloadModel.title = "地表模型";
          downloadModel.epsg = "32644";
          downloadModel.epsgvalue = 4326;
          downloadModel.format = "gtiff";
          downloadModel.projectId = row.project;
          downloadModel.taskId = row.id;
          downloadModel.type = "dsm";
          downloadModel.open = true;
          break;
        case "georeferenced_model.laz":
          downloadModel.title = "点云(LAZ)";
          downloadModel.epsg = "32644";
          downloadModel.epsgvalue = 4326;
          downloadModel.format = "laz";
          downloadModel.projectId = row.project;
          downloadModel.taskId = row.id;
          downloadModel.type = "georeferenced_model";
          downloadModel.open = true;
          break;
        case "textured_model.zip":
          downloadFile("/3d/api/projects/" + row.project + "/tasks/" + row.id + "/download/textured_model.zip", row.name + "-textured_model.zip");
          break;
        case "textured_model.glb":
          downloadFile("/3d/api/projects/" + row.project + "/tasks/" + row.id + "/download/textured_model.glb", row.name + "-textured_model.glb");
          break;
        case "cameras.json":
          downloadFile("/3d/api/projects/" + row.project + "/tasks/" + row.id + "/download/cameras.json", row.name + "-cameras.json");
          break;
        case "shots.geojson":
          downloadFile("/3d/api/projects/" + row.project + "/tasks/" + row.id + "/download/shots.geojson", row.name + "-shots.geojson");
          break;
        case "report.pdf":
          downloadFile("/3d/api/projects/" + row.project + "/tasks/" + row.id + "/download/report.pdf", row.name + "-report.pdf");
          break;
        case "all.zip":
          downloadFile("/3d/api/projects/" + row.project + "/tasks/" + row.id + "/download/all.zip", row.name + "-all.zip");
          break;
        default:
          break;
      }
    }
    function downloadFile(url, filename) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "get",
        url: url,
        responseType: 'blob'
      };
      mgAxios.request(options).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // 设置下载的文件名
        document.body.appendChild(link);
        link.click();
        if (downloadModel.open) {
          downloadModelCancel();
        }
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function handleCommand(command, row) {
      switch (command) {
        case "edit":
          handleEdit(row);
          break;
        case "copy":
          handleCopy(row);
          break;
        case "delete":
          deleteTask(row);
          break;
        default:
          break;
      }
    }
    function handleEdit(row) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      let options = {
        method: "GET",
        url: "/3d/api/processingnodes/?has_available_options=True"
      };
      mgAxios.request(options).then(result => {
        nodeList.value = result.data;
        nodeList.value.map(item => {
          if (item.online) {
            taskform.value.processing_node = item.id;
          }
        });
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
      options = {
        method: "GET",
        url: "/3d/api/presets/?ordering=-system,-created_at"
      };
      mgAxios.request(options).then(result => {
        presetTypes.value = result.data;
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
      taskform.value = row;
      image.title = "编辑信息";
      image.open = true;
    }
    function editCommit() {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "PATCH",
        url: "/3d/api/projects/" + taskform.value.project + "/tasks/" + taskform.value.id + "/",
        data: taskform.value
      };
      mgAxios.request(options).then(result => {
        image.open = false;
        image.title = "";
        getExpandData(taskform.value.project);
        taskform.value = {};
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    function handleCopy(row) {
      const mgAxios = axios.create({
        headers: {
          Authorization: odmtoken.value,
          "content-type": "application/json"
        },
        timeout: 15000
      });
      const options = {
        method: "POST",
        url: "/3d/api/projects/" + row.project + "/tasks/" + row.id + "/duplicate/",
        data: {
          "uuid": row.uuid
        }
      };
      mgAxios.request(options).then(result => {
        getTaskCount(row.project);
        getExpandData(row.project);
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    }
    getOdmToken();
    return (_ctx, _cache) => {
      const _component_Plus = _resolveComponent("Plus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_Back = _resolveComponent("Back");
      const _component_Expand = _resolveComponent("Expand");
      const _component_Fold = _resolveComponent("Fold");
      const _component_Edit = _resolveComponent("Edit");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_Download = _resolveComponent("Download");
      const _component_arrow_down = _resolveComponent("arrow-down");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_View = _resolveComponent("View");
      const _component_ElementPlus = _resolveComponent("ElementPlus");
      const _component_CircleClose = _resolveComponent("CircleClose");
      const _component_Delete = _resolveComponent("Delete");
      const _component_ArrowRightBold = _resolveComponent("ArrowRightBold");
      const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
      const _component_Picture = _resolveComponent("Picture");
      const _component_Clock = _resolveComponent("Clock");
      const _component_dot = _resolveComponent("dot");
      const _component_MoreFilled = _resolveComponent("MoreFilled");
      const _component_EditPen = _resolveComponent("EditPen");
      const _component_CopyDocument = _resolveComponent("CopyDocument");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Upload = _resolveComponent("Upload");
      const _component_BottomRight = _resolveComponent("BottomRight");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_UserFilled = _resolveComponent("UserFilled");
      const _component_CloseBold = _resolveComponent("CloseBold");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_DocumentAdd = _resolveComponent("DocumentAdd");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_Right = _resolveComponent("Right");
      const _component_UploadFilled = _resolveComponent("UploadFilled");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_input_number = _resolveComponent("el-input-number");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(showChild) === false ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "new_button"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: projectAdd
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[18] || (_cache[18] = _createTextVNode("新建工程", -1))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _unref(showChild) === true ? (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "back_button"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: goBack
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Back)]),
            _: 1
          }), _cache[19] || (_cache[19] = _createTextVNode("返回", -1))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _unref(showChild) === false ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
        class: "textinfo"
      }, "三维生成", -1)]))])) : _createCommentVNode("", true), _unref(showChild) === false ? (_openBlock(), _createBlock(_component_el_table, {
        key: 3,
        data: _unref(tableData),
        "row-key": "id",
        "expand-row-keys": _unref(expandedRows),
        "show-header": false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          align: "left",
          prop: "expandname"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_5, _toDisplayString(scope.row.name), 1), _createElementVNode("div", null, [scope.row.tasks.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createVNode(_component_el_button, {
            link: "",
            size: "default",
            class: "btnClass",
            onClick: $event => expandChange(scope.row)
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.5rem",
                "margin-top": "0.1rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_Expand)]),
              _: 1
            }, 512), [[_vShow, scope.row.id !== _unref(expandedRows)[0]]]), _withDirectives(_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.5rem",
                "margin-top": "0.1rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_Fold)]),
              _: 1
            }, 512), [[_vShow, scope.row.id === _unref(expandedRows)[0]]]), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(countmap).get(scope.row.id)), 1)]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: $event => projectEdit(scope.row),
            style: {
              "color": "#1890ff"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.6rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_Edit)]),
              _: 1
            }), _cache[21] || (_cache[21] = _createTextVNode("编辑", -1))]),
            _: 1
          }, 8, ["onClick"])])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          type: "expand",
          width: "1"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_table, {
            data: _unref(map).get(scope.row.id),
            "show-header": false,
            "row-key": "id",
            "expand-row-keys": _unref(middleRowKeys)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "expand"
            }, {
              default: _withCtx(props => [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, "创建于: " + _toDisplayString(_ctx.parseTime(new Date(props.row.created_at), '{y}-{m}-{d} {h}:{i}:{s}')), 1), _createElementVNode("p", _hoisted_10, "处理节点: " + _toDisplayString(props.row.processing_node_name) + "(" + _toDisplayString(props.row.auto_processing_node ? '自动' : '手动') + ")", 1), _createElementVNode("p", _hoisted_11, "选项: " + _toDisplayString(getOptions(props.row.options)), 1), props.row.statistics.gsd !== undefined && props.row.statistics.gsd !== null ? (_openBlock(), _createElementBlock("p", _hoisted_12, "平均GSD: " + _toDisplayString(props.row.statistics.gsd.toFixed(1)) + "cm", 1)) : _createCommentVNode("", true), props.row.statistics.area !== undefined && props.row.statistics.area !== null ? (_openBlock(), _createElementBlock("p", _hoisted_13, "区域: " + _toDisplayString(props.row.statistics.area.toFixed(1)) + "m²", 1)) : _createCommentVNode("", true), props.row.statistics.pointcloud !== undefined && props.row.statistics.pointcloud !== null ? (_openBlock(), _createElementBlock("p", _hoisted_14, "重建点: " + _toDisplayString(props.row.statistics.pointcloud !== null ? props.row.statistics.pointcloud.points : ""), 1)) : _createCommentVNode("", true), props.row.size !== undefined && props.row.size !== null ? (_openBlock(), _createElementBlock("p", _hoisted_15, "磁盘使用: " + _toDisplayString(props.row.size.toFixed(2)) + "Mb", 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_16, [_cache[22] || (_cache[22] = _createTextVNode(" 任务输出: ", -1)), _createVNode(_component_el_switch, {
                modelValue: _unref(resultmap).get(props.row.id).resultshow,
                "onUpdate:modelValue": $event => _unref(resultmap).get(props.row.id).resultshow = $event,
                onChange: $event => getResult(props.row),
                "inline-prompt": "",
                "active-text": "开",
                "inactive-text": "关"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]), _unref(resultmap).get(props.row.id).resultshow == true ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": $event => _unref(resultmap).get(props.row.id).textarea = $event,
                rows: 15,
                readonly: "",
                id: "talkContent"
              }, null, 8, _hoisted_18), [[_vModelText, _unref(resultmap).get(props.row.id).textarea]])])) : _createCommentVNode("", true), _createElementVNode("span", null, [props.row.status === 40 ? (_openBlock(), _createBlock(_component_el_dropdown, {
                key: 0,
                trigger: "click",
                onCommand: $event => handleDownloadCommand($event, props.row),
                style: {
                  "margin-right": "1rem"
                }
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(downloadOptions), item => {
                    return _openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: item.value,
                      command: item.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                      _: 2
                    }, 1032, ["command"]);
                  }), 128))]),
                  _: 1
                })]),
                default: _withCtx(() => [_createElementVNode("span", _hoisted_19, [_createVNode(_component_el_button, {
                  style: {
                    "background-color": "#606266 !important"
                  },
                  onClick: _cache[0] || (_cache[0] = () => {}),
                  type: "info"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, {
                    style: {
                      "margin-right": "0.6rem"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_Download)]),
                    _: 1
                  }), _cache[23] || (_cache[23] = _createTextVNode("下载资产", -1)), _createVNode(_component_el_icon, {
                    class: "el-icon--right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_arrow_down)]),
                    _: 1
                  })]),
                  _: 1
                })])]),
                _: 1
              }, 8, ["onCommand"])) : _createCommentVNode("", true), props.row.status === 40 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                style: {
                  "background-color": "#606266 !important"
                },
                onClick: $event => viewMap(props.row),
                type: "info"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  style: {
                    "margin-right": "0.6rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_View)]),
                  _: 1
                }), _cache[24] || (_cache[24] = _createTextVNode("查看地图", -1))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true), props.row.status === 40 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                style: {
                  "background-color": "#606266 !important"
                },
                onClick: $event => viewMap(props.row, '3d'),
                type: "info"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  style: {
                    "margin-right": "0.6rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_ElementPlus)]),
                  _: 1
                }), _cache[25] || (_cache[25] = _createTextVNode("查看3D模型", -1))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true), props.row.status === 20 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                style: {
                  "background-color": "#606266 !important"
                },
                onClick: $event => taskRunCancel(props.row),
                type: "info"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  style: {
                    "margin-right": "0.6rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_CircleClose)]),
                  _: 1
                }), _cache[26] || (_cache[26] = _createTextVNode("取消", -1))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
                style: {
                  "background-color": "#ee4f12 !important"
                },
                onClick: $event => deleteTask(props.row),
                type: "danger"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  style: {
                    "margin-right": "0.6rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_Delete)]),
                  _: 1
                }), _cache[27] || (_cache[27] = _createTextVNode("删除", -1))]),
                _: 1
              }, 8, ["onClick"])])])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "name",
              align: "left",
              width: "600"
            }, {
              default: _withCtx(props => [_createVNode(_component_el_button, {
                link: "",
                size: "default",
                class: "btnClass",
                onClick: $event => expandMiddleChange(props.row)
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, {
                  style: {
                    "margin-right": "1rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
                  _: 1
                }, 512), [[_vShow, props.row.id !== _unref(middleRowKeys)[0]]]), _withDirectives(_createVNode(_component_el_icon, {
                  style: {
                    "margin-right": "1rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
                  _: 1
                }, 512), [[_vShow, props.row.id === _unref(middleRowKeys)[0]]])]),
                _: 2
              }, 1032, ["onClick"]), _createElementVNode("span", _hoisted_20, _toDisplayString(formateName(props.row)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "images_count",
              prop: "images_count"
            }, {
              default: _withCtx(props => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Picture)]),
                _: 1
              }), _createTextVNode(" " + _toDisplayString(props.row.images_count), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "processing_time",
              prop: "processing_time"
            }, {
              default: _withCtx(props => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Clock)]),
                _: 1
              }), _createTextVNode(" " + _toDisplayString(props.row.processing_time === undefined || props.row.processing_time === -1 ? "--:--:--" : _ctx.getTime(props.row.processing_time / 1000)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "status",
              prop: "status",
              style: {
                "color": "#f59090"
              }
            }, {
              default: _withCtx(props => [_createElementVNode("span", {
                style: _normalizeStyle(props.row.status === 40 ? 'color: #47ab74' : props.row.status === 50 ? 'color: #a6aebe' : props.row.status === 30 ? 'color: #f59090' : 'color: #FFFFF')
              }, _toDisplayString(_unref(statusmap).get(props.row.id)), 5), _createElementVNode("div", _hoisted_21, [props.row.status === 20 || props.row.status === null ? (_openBlock(), _createBlock(_component_dot, {
                key: 0
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("。。。", -1)]))]),
                _: 1
              })) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              align: "right"
            }, {
              default: _withCtx(props => [_createVNode(_component_el_dropdown, {
                onCommand: $event => handleCommand($event, props.row)
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                    command: "edit"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_EditPen)]),
                      _: 1
                    }), _cache[29] || (_cache[29] = _createTextVNode("编辑", -1))]),
                    _: 1
                  }), _createVNode(_component_el_dropdown_item, {
                    command: "copy"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
                      _: 1
                    }), _cache[30] || (_cache[30] = _createTextVNode("复制", -1))]),
                    _: 1
                  }), _createVNode(_component_el_dropdown_item, {
                    divided: "",
                    command: "delete"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_Delete)]),
                      _: 1
                    }), _cache[31] || (_cache[31] = _createTextVNode("删除", -1))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                default: _withCtx(() => [_createElementVNode("span", _hoisted_22, [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_MoreFilled)]),
                  _: 1
                })])]),
                _: 1
              }, 8, ["onCommand"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data", "expand-row-keys"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          align: "right",
          "class-name": "small-padding fixed-width",
          width: "1080"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            onClick: $event => handleSelectPic(scope.row)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.6rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_Upload)]),
              _: 1
            }), _cache[32] || (_cache[32] = _createTextVNode("选择图片和GCP", -1))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            onClick: $event => handleImport(scope.row)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.6rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_BottomRight)]),
              _: 1
            }), _cache[33] || (_cache[33] = _createTextVNode("导入", -1))]),
            _: 1
          }, 8, ["onClick"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "expand-row-keys"])) : _createCommentVNode("", true), _unref(showChild) === true ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("iframe", {
        scrolling: "no",
        title: "WebODM",
        width: "100%",
        height: "100%",
        frameBorder: "0",
        src: _unref(src)
      }, null, 8, _hoisted_24)])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogFormVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogFormVisible) ? dialogFormVisible.value = $event : null),
        title: _unref(title),
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: handleClose,
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_unref(form).id !== undefined ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          style: {
            "background-color": "#ee4f12 !important",
            "float": "left"
          },
          onClick: projectDelete,
          type: "danger"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Delete)]),
            _: 1
          }), _cache[34] || (_cache[34] = _createTextVNode("删除", -1))]),
          _: 1
        })) : _createCommentVNode("", true), _unref(form).id !== undefined ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          style: {
            "background-color": "#7b98bc !important",
            "float": "left"
          },
          onClick: duplicate,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
            _: 1
          }), _cache[35] || (_cache[35] = _createTextVNode("Duplicate", -1))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          style: {
            "background-color": "#7b98bc !important"
          },
          onClick: handleClose,
          type: "info"
        }, {
          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _unref(form).id !== undefined ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          style: {
            "background-color": "#606266 !important"
          },
          onClick: submitForm,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Edit)]),
            _: 1
          }), _cache[37] || (_cache[37] = _createTextVNode("保存更改", -1))]),
          _: 1
        })) : _createCommentVNode("", true), _unref(form).id === undefined ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          style: {
            "background-color": "#606266 !important"
          },
          onClick: submitForm,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[38] || (_cache[38] = _createTextVNode("创建项目", -1))]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "formRef",
          model: _unref(form),
          rules: _unref(rules)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名字",
            "label-width": _unref(formLabelWidth),
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label-width"]), _createVNode(_component_el_form_item, {
            label: "描述(可选)",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).description = $event),
              rows: 2,
              type: "textarea"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label-width"]), _unref(form).id !== undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "Permissions",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).permissions, (item, index) => {
              return _openBlock(), _createBlock(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: item.username,
                      "onUpdate:modelValue": $event => item.username = $event,
                      disabled: item.owner,
                      placeholder: "Username",
                      style: {
                        "width": "30rem"
                      }
                    }, {
                      prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [_createVNode(_component_UserFilled)]),
                        _: 1
                      })]),
                      suffix: _withCtx(() => [!item.owner ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: $event => delPermissions(index),
                        style: {
                          "border": "none !important"
                        }
                      }, {
                        default: _withCtx(() => [_createVNode(_component_el_icon, {
                          style: {
                            "color": "#606266 !important"
                          }
                        }, {
                          default: _withCtx(() => [_createVNode(_component_CloseBold)]),
                          _: 1
                        })]),
                        _: 1
                      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [_createVNode(_component_el_select, {
                      modelValue: item.per,
                      "onUpdate:modelValue": $event => item.per = $event,
                      disabled: item.owner
                    }, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(permissionsOptions), dict => {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: dict.value,
                          label: dict.label,
                          value: dict.value
                        }, null, 8, ["label", "value"]);
                      }), 128))]),
                      _: 1
                    }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  style: {
                    "height": "0.5rem"
                  }
                })]),
                _: 2
              }, 1024);
            }), 256))]),
            _: 1
          }, 8, ["label-width"])) : _createCommentVNode("", true), _unref(form).id !== undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            "label-width": _unref(formLabelWidth),
            style: {
              "margin-top": "-1.5rem !important"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: addPermissions
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                style: {
                  "color": "#606266 !important"
                },
                size: "20"
              }, {
                default: _withCtx(() => [_createVNode(_component_DocumentAdd)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["label-width"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _unref(upload).open ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 5,
        title: "导入",
        modelValue: _unref(upload).open,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(upload).open = $event),
        width: "85rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_cache[45] || (_cache[45] = _createElementVNode("div", null, "导入现有资产", -1)), _createElementVNode("div", null, [_cache[39] || (_cache[39] = _createTextVNode("您可以通过下载资源", -1)), _createVNode(_component_el_icon, {
          color: "black",
          size: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_Right)]),
          _: 1
        }), _cache[40] || (_cache[40] = _createTextVNode("导入从现有任务导出的.zip文件。", -1))]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_upload, {
          ref: "uploadRef",
          limit: 1,
          "show-file-list": false,
          headers: _unref(upload).headers,
          action: _unref(upload).url,
          data: _unref(upload).data,
          "on-progress": handleProgress,
          "on-error": handleUploadError,
          "on-success": handleUploadSuccess,
          "auto-upload": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            style: {
              "background-color": "#606266 !important"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.6rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_UploadFilled)]),
              _: 1
            }), _cache[41] || (_cache[41] = _createTextVNode("点击上传", -1))]),
            _: 1
          })]),
          _: 1
        }, 8, ["headers", "action", "data"])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
          style: {
            "background-color": "#606266 !important"
          },
          onClick: changeImport
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Download)]),
            _: 1
          }), _cache[42] || (_cache[42] = _createTextVNode("从URL导入", -1))]),
          _: 1
        })])]), _unref(progressFlag) ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_el_progress, {
          percentage: _unref(loadProgress)
        }, null, 8, ["percentage"]), _createVNode(_component_el_button, {
          style: {
            "background-color": "#ee4f12 !important",
            "margin-top": "1rem"
          },
          onClick: handleCancel
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_CircleClose)]),
            _: 1
          }), _cache[43] || (_cache[43] = _createTextVNode("取消上传", -1))]),
          _: 1
        })])) : _createCommentVNode("", true), _unref(isShow) == true ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_input, {
          modelValue: _unref(url),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(url) ? url.value = $event : null),
          placeholder: "http://",
          style: {
            "width": "35rem"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          style: {
            "background-color": "#747a87 !important",
            "margin-left": "1rem"
          },
          disabled: _unref(url) === '' || _unref(url) === null || _unref(url) === undefined,
          onClick: urlImport
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Download)]),
            _: 1
          }), _cache[44] || (_cache[44] = _createTextVNode("导入", -1))]),
          _: 1
        }, 8, ["disabled"])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _unref(image).title,
        modelValue: _unref(image).open,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(image).open = $event),
        width: "85rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_button, {
          style: {
            "background-color": "#ee4f12 !important"
          },
          onClick: taskCancel,
          type: "info"
        }, {
          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _unref(taskform).id === undefined && _unref(isChecked) === false ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          style: {
            "background-color": "#606266 !important"
          },
          onClick: taskCheck,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Edit)]),
            _: 1
          }), _cache[49] || (_cache[49] = _createTextVNode("审查", -1))]),
          _: 1
        })) : _createCommentVNode("", true), _unref(taskform).id === undefined && _unref(isChecked) === true ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          style: {
            "background-color": "#606266 !important"
          },
          onClick: taskSubmitForm,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[50] || (_cache[50] = _createTextVNode("开始处理", -1))]),
          _: 1
        })) : _createCommentVNode("", true), _unref(taskform).id !== undefined ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          style: {
            "background-color": "#606266 !important"
          },
          onClick: editCommit,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Edit)]),
            _: 1
          }), _cache[51] || (_cache[51] = _createTextVNode("保存", -1))]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_unref(taskform).id === undefined ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_el_upload, {
          disabled: _unref(isChecked),
          ref: "uploadImgRef",
          multiple: "",
          "show-file-list": false,
          headers: _unref(image).headers,
          action: _unref(image).url,
          "on-change": handleUploadChange,
          "on-success": handleImageUploadSuccess,
          "auto-upload": false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            style: {
              "background-color": "#606266 !important"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-right": "0.6rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_UploadFilled)]),
              _: 1
            }), _cache[46] || (_cache[46] = _createTextVNode("点击上传", -1))]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled", "headers", "action"])])]), _createElementVNode("div", null, _toDisplayString(_unref(image).count) + "文件选中。请检查这些附加选项：", 1)])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
          ref: "taskformRef",
          model: _unref(taskform)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名字",
            "label-width": _unref(formLabelWidth),
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(taskform).name,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(taskform).name = $event),
              autocomplete: "off",
              disabled: _unref(isChecked)
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }, 8, ["label-width"]), _createVNode(_component_el_form_item, {
            label: "处理节点",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(taskform).processing_node,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(taskform).processing_node = $event),
              placeholder: "请选择",
              disabled: _unref(isChecked),
              style: {
                "width": "34rem"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nodeList), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.id,
                  label: dict.label + '(queue:' + dict.queue_count + ')',
                  value: dict.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }, 8, ["label-width"]), _createVNode(_component_el_form_item, {
            label: "选项",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(selectType),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(selectType) ? selectType.value = $event : null),
              placeholder: "请选择",
              onChange: _cache[9] || (_cache[9] = $event => setOption(_unref(selectType))),
              disabled: _unref(isChecked),
              style: {
                "width": "34rem"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presetTypes), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.id,
                  label: dict.name,
                  value: dict.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }, 8, ["label-width"]), _unref(taskform).id === undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "调整图片尺寸",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(taskform).partial,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(taskform).partial = $event),
              placeholder: "请选择",
              disabled: _unref(isChecked)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partialList), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "disabled"]), _createVNode(_component_el_input_number, {
              modelValue: _unref(taskform).resize_to,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(taskform).resize_to = $event),
              "controls-position": "right",
              min: 0,
              disabled: _unref(isChecked)
            }, null, 8, ["modelValue", "disabled"]), _cache[47] || (_cache[47] = _createTextVNode("像素 ", -1))]),
            _: 1
          }, 8, ["label-width"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(downloadModel).open,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(downloadModel).open = $event),
        title: _unref(downloadModel).title,
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: downloadModelCancel,
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createVNode(_component_el_button, {
          style: {
            "background-color": "#7b98bc !important"
          },
          onClick: downloadModelCancel,
          type: "info"
        }, {
          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _unref(downloadModel).loading === false ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          style: {
            "background-color": "#606266 !important"
          },
          onClick: downloadModelCommit,
          type: "info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "0.6rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Download)]),
            _: 1
          }), _cache[53] || (_cache[53] = _createTextVNode("下载", -1))]),
          _: 1
        })) : _createCommentVNode("", true), _unref(downloadModel).loading === true ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          style: {
            "background-color": "#606266 !important"
          },
          loading: _unref(downloadModel).loading,
          type: "info"
        }, {
          default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode("下载中...", -1)]))]),
          _: 1
        }, 8, ["loading"])) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "投影:",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(downloadModel).epsg,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(downloadModel).epsg = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectionOptions), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label-width"]), _unref(downloadModel).epsg === 'custom' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "EPSG:",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(downloadModel).epsgvalue,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(downloadModel).epsgvalue = $event),
              "controls-position": "right",
              min: 0
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label-width"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "格式",
            "label-width": _unref(formLabelWidth)
          }, {
            default: _withCtx(() => [_unref(downloadModel).title === '正射影像' || _unref(downloadModel).title === '地表模型' ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: _unref(downloadModel).format,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(downloadModel).format = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formatOptions), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])) : _createCommentVNode("", true), _unref(downloadModel).title === '点云(LAZ)' ? (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: _unref(downloadModel).format,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(downloadModel).format = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lasOptions), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["label-width"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"])])])]);
    };
  }
};